// Packages and components
import React, { useContext } from 'react';
import { Box, Image } from 'grommet';
import SHDButton from '@ui/Button/SHDButton';
import SHDFooter from '@ui/Footer/SHDFooter';
import SHDHeading from '@ui/Heading/SHDHeading';
import SHDModalContainer from '@ui/ModalContainer/SHDModalContainer';
import SHDText from '@ui/Text/SHDText';

// Helpers and utlities
import { formatDateTime } from '@helpers/dateUtils';

// Contexts and hooks
import { ResponsiveContext } from 'grommet';

// Types and interfaces
interface SettingsConfirmCancelSubscriptionProps {
  expirationTs: number;
  onClose: () => void;
}

const SettingsConfirmCancelSubscription: React.FC<
  SettingsConfirmCancelSubscriptionProps
> = ({ expirationTs, onClose }) => {
  const screenSize = useContext(ResponsiveContext);
  const { date: expiresAtDate } = formatDateTime(expirationTs, 'MMM dd, yyyy');
  const checkmarkStyles: React.CSSProperties =
    screenSize === 'small' || screenSize === 'medium'
      ? {
          left: '42%',
          position: 'absolute',
          top: '35%',
        }
      : {
          paddingTop: '60px',
          paddingBottom: '30px',
        };

  return (
    <>
      <Box
        align="center"
        direction="column"
        justify="center"
        style={checkmarkStyles}
      >
        <Image
          width={120}
          height={120}
          src="/icons/icon_confirmed.png"
          alt="Confirmed"
        />
      </Box>
      <SHDFooter>
        <SHDModalContainer>
          <Box gap="xsmall" margin={{ bottom: 'xxlarge' }}>
            <SHDHeading level={3} textAlign="center">
              Your membership was cancelled
            </SHDHeading>
            <SHDText color="black-alpha-70" style="subhead" textAlign="center">
              You&apos;ll still have Pro access until {expiresAtDate}.
            </SHDText>
          </Box>
          <SHDButton primary label="Done" onClick={onClose} />
        </SHDModalContainer>
      </SHDFooter>
    </>
  );
};
export default SettingsConfirmCancelSubscription;
